export default class GoogleApiProvider {
  getGoogleLoginToken = (): Promise<string> => {
    return new Promise((resolve, reject) => {
      const clientID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

      if (clientID) {
        return gapi.load("client:auth2", () => {
          gapi.auth2.authorize(
            {
              client_id: clientID,
              response_type: "id_token permission",
              scope: "profile",
            },
            (response) => {
              if (response.error) {
                return reject({
                  response: {
                    data: response.error,
                  },
                });
              } else {
                const token = response.id_token;

                if (token) {
                  return resolve(token);
                } else {
                  return reject({
                    response: {
                      data: {
                        error_description: ["The token can't be retrieved"],
                      },
                    },
                  });
                }
              }
            }
          );
        });
      } else {
        return reject({
          response: {
            data: "Google client id is missing",
          },
        });
      }
    });
  };
}
